import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TableComponent } from '../table/table.component';
import { CommonModule } from '@angular/common';
import { PagesService } from '@services/pages.service';
import { SharedService } from '@services/shared.service';
import * as FileSaver from 'file-saver';
import { NgZorroAntdModule } from 'src/app/ng-zorro-antd.module';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { Workbook } from 'exceljs';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { TranslateModule } from '@ngx-translate/core';
import { FilterModalComponent, FilterConfig } from '@pages/filter-modal/filter-modal.component';
import { FormsModule } from '@angular/forms';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-analysis-contest-monitoring',
  standalone: true,
  imports: [
    CommonModule,
    TableComponent,
    NgZorroAntdModule,
    NzToolTipModule,
    TranslateModule,
    FilterModalComponent,
    FormsModule
  ],
  templateUrl: './analysis-contest-monitoring.component.html',
  styleUrls: ['./analysis-contest-monitoring.scss'],
})
export class AnalysisContestMonitoringComponent implements OnInit {

  listOfData: any[] = [];
  analysis: any[] = [];
  analytic3: any;
  isFilterVisible = false;
  appliedFilters: any = {};
  filteredData: any[] = [];
  searchTerm: string = '';

  // Add these properties to your component class
  previousWeekMetrics = {
    totalViews: 0,
    numberOfJoins: 0,
    completionRate: 0,
    totalClicks: 0
  };

  private route = inject(ActivatedRoute)
  private pageService = inject(PagesService)
  private sharedService = inject(SharedService)
  private router = inject(Router)
  @ViewChild(FilterModalComponent) filterModalComponent!: FilterModalComponent;

  // Filter configuration for modal
  filterConfig: FilterConfig = {
    showTimeline: true,
    showStatus: true,
    showLocation: true,
    showFormat: true,
    showType: true,
    showViewType: true,
    showLevel: false,
    statusOptions: [
      { value: 'in_progress', label: 'In Progress' },
      { value: 'completed', label: 'Completed' },
      { value: 'pending', label: 'Pending' }
    ],
    formatOptions: [
      { value: 'integrated', label: 'Integrated' },
      { value: 'non-integrated', label: 'Non-Integrated' }
    ],
    typeOptions: [
      { value: 'private', label: 'Private' },
      { value: 'public', label: 'Public' }
    ],
    viewTypeOptions: [
      { value: 'Recent Contest', label: 'Recent Contest' },
      { value: 'Popular Contest', label: 'Popular Contest' },
      { value: 'Featured Contest', label: 'Featured Contest' }
    ]
  };
  columns = [
    { name: 'contestTableMonitoring.participantName', key: 'participant', width: 'auto', },
    { name: 'contestTableMonitoring.email', key: 'email', width: 'auto' },
    { name: 'contestTableMonitoring.userLocation', key: 'userLocation', width: 'auto' },
    { name: 'contestTableMonitoring.prize', key: 'prize', width: 'auto' },
    { name: 'contestTableMonitoring.joinDate', key: 'joinDate', width: 'auto', },
  ];

  constructor() { }

  ngOnInit() {
    this.analytic3 = [
      {
        title: 'analytic3.totalViews',
        number: 0,
        percentage: 0,
        progressText: 'analytic3.onThisWeek',
        icon: 'assets/images/visitor.svg',
        tooltip: 'analytic3.totalViewsTooltip',
      },
      {
        title: 'analytic3.numberOfJoins',
        number: 0,
        percentage: 0,
        progressText: 'analytic3.onThisWeek',
        icon: 'assets/images/participant.svg',
        tooltip: 'analytic3.numberOfJoinsTooltip',
      },
      {
        title: 'analytic3.completionRate',
        number: 0,
        percentage: 0,
        progressText: 'analytic3.onThisWeek',
        icon: 'assets/images/view.svg',
        tooltip: 'analytic3.completionRateTooltip',
      },
      {
        title: 'analytic3.totalClicks',
        number: 0,
        percentage: 0,
        progressText: 'analytic3.onThisWeek',
        icon: 'assets/images/clicks.svg',
        tooltip: 'analytic3.totalClicksTooltip',
      },
    ];
    this.route.queryParams.subscribe((params) => {
      const id = params['contest_id'];
      if (id) {
        this.loadDetail(id);
      }
    });
  }
  loadDetail(id: number) {
    this.sharedService.showLoader();

    // First, fetch previous week data
    this.fetchPreviousWeekData(id).then(() => {
      // Then fetch current data
      this.pageService
        .getByIdByQuerry('ANALYSIS_URL_Reports_DETAIL', id)
        .subscribe({
          next: (res) => {
            this.listOfData = this.mapResponseToTable(res);
            this.filteredData = [...this.listOfData];

            const dataArray = Array.isArray(res) ? res : res.data;
            this.calculateAnalysisMetrics(dataArray);
            this.sharedService.hideLoader();
          },
          error: () => {
            this.sharedService.hideLoader();
            this.sharedService.createNotification(
              'error',
              'Failed to load contest monitoring'
            );
          },
        });
    });
  }
  async fetchPreviousWeekData(id: number): Promise<void> {
    return new Promise((resolve) => {
      // Calculate date range for previous week
      const today = new Date();
      const lastWeekStart = new Date(today.getTime() - 14 * 24 * 60 * 60 * 1000);
      const lastWeekEnd = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);

      // Fetch previous week data
      // If your API supports date filtering, add date parameters here
      this.pageService
        .getByIdByQuerry('ANALYSIS_URL_Reports_DETAIL', id)
        .subscribe({
          next: (res) => {
            const dataArray = Array.isArray(res) ? res : res.data;

            // Filter data for previous week
            const previousWeekData = dataArray.filter((item: any) => {
              if (!item.joinDate || item.joinDate === 'N/A') return false;
              const joinDate = new Date(item.joinDate);
              return joinDate >= lastWeekStart && joinDate < lastWeekEnd;
            });

            // Calculate previous week metrics
            this.previousWeekMetrics.totalViews = previousWeekData.length;
            this.previousWeekMetrics.numberOfJoins = previousWeekData.filter(
              (u: any) => u.contestId
            ).length;

            const totalUsers = previousWeekData.length;
            const completedUsers = previousWeekData.filter(
              (u: any) => u.status?.toLowerCase() === 'completed'
            ).length;
            this.previousWeekMetrics.completionRate =
              totalUsers > 0 ? Math.round((completedUsers / totalUsers) * 100) : 0;

            this.previousWeekMetrics.totalClicks = previousWeekData.reduce(
              (acc: number, u: any) =>
                acc + (u.levelsCompleted || 0) + (u.levelsInProgress || 0),
              0
            );

            resolve();
          },
          error: () => {
            // If previous week data fetch fails, use default values (0)
            resolve();
          },
        });
    });
  }

  // Optional: If you want to store metrics in localStorage for persistence
  savePreviousWeekMetrics() {
    localStorage.setItem(
      'previousWeekMetrics',
      JSON.stringify(this.previousWeekMetrics)
    );
  }

  loadPreviousWeekMetrics() {
    const stored = localStorage.getItem('previousWeekMetrics');
    if (stored) {
      this.previousWeekMetrics = JSON.parse(stored);
    }
  }

  // Call this at the end of each week to update baseline
  updateWeeklyBaseline(res: any[]) {
    const totalViews = res.length;
    const numberOfJoins = res.filter((u) => u.contestId).length;
    const totalUsers = res.length;
    const completedUsers = res.filter(
      (u) => u.status?.toLowerCase() === 'completed'
    ).length;
    const completionRate =
      totalUsers > 0 ? Math.round((completedUsers / totalUsers) * 100) : 0;
    const totalClicks = res.reduce(
      (acc, u) => acc + (u.levelsCompleted || 0) + (u.levelsInProgress || 0),
      0
    );

    this.previousWeekMetrics = {
      totalViews,
      numberOfJoins,
      completionRate,
      totalClicks
    };

    this.savePreviousWeekMetrics();
  }


  // Modified calculateAnalysisMetrics method
  calculateAnalysisMetrics(res: any[]) {
    // Current week metrics
    const totalViews = res.length;
    const numberOfJoins = res.filter((u) => u.contestId).length;
    const totalUsers = res.length;
    const completedUsers = res.filter(
      (u) => u.status?.toLowerCase() === 'completed'
    ).length;
    const completionRate =
      totalUsers > 0 ? Math.round((completedUsers / totalUsers) * 100) : 0;
    const totalClicks = res.reduce(
      (acc, u) => acc + (u.levelsCompleted || 0) + (u.levelsInProgress || 0),
      0
    );

    // Calculate percentage changes
    const viewsChange = this.calculatePercentageChange(
      this.previousWeekMetrics.totalViews,
      totalViews
    );
    const joinsChange = this.calculatePercentageChange(
      this.previousWeekMetrics.numberOfJoins,
      numberOfJoins
    );
    const completionRateChange = this.calculatePercentageChange(
      this.previousWeekMetrics.completionRate,
      completionRate
    );
    const clicksChange = this.calculatePercentageChange(
      this.previousWeekMetrics.totalClicks,
      totalClicks
    );

    this.analytic3 = this.analytic3.map((card: any) => {
      switch (card.title) {
        case 'analytic3.totalViews':
          return { ...card, number: totalViews, percentage: viewsChange };
        case 'analytic3.numberOfJoins':
          return { ...card, number: numberOfJoins, percentage: joinsChange };
        case 'analytic3.completionRate':
          return { ...card, number: completionRate + '%', percentage: completionRateChange };
        case 'analytic3.totalClicks':
          return { ...card, number: totalClicks, percentage: clicksChange };
        default:
          return card;
      }
    });
  }
  calculatePercentageChange(previousValue: number, currentValue: number): number {
    if (previousValue === 0) {
      // If previous value is 0, return 100% if current is positive, 0 otherwise
      return currentValue > 0 ? 100 : 0;
    }

    const difference = currentValue - previousValue;
    const percentageChange = (difference / previousValue) * 100;

    // Cap the percentage at ±100%
    if (percentageChange > 100) return 100;
    if (percentageChange < -100) return -100;

    return Math.round(percentageChange);
  }


  private mapResponseToTable(res: any): any[] {
    if (!res) return [];
    const dataArray = Array.isArray(res) ? res : [res];
    return dataArray.map((item: any) => ({
      ...item, // Keep all original fields
      participant: item.userName || 'N/A',
      email: item.email || 'N/A',
      userLocation: item.userLocation || 'N/A',
      prize: item.status || 'N/A',
      joinDate: item.joinDate || 'N/A',
    }));
  }
  goBack(): void {
    this.router.navigate(['/home/analytic']);
  }
  // Tooltip methods
  onMouseEnter(event: MouseEvent, value: string) {
    if (!value || value.length <= 12) return;
    const container = event.currentTarget as HTMLElement;
    const tooltip = container.querySelector('.custom-tooltip') as HTMLElement;
    if (tooltip) {
      const rect = container.getBoundingClientRect();
      const left = rect.left + (rect.width / 2);
      const top = rect.top - 8;
      tooltip.style.position = 'fixed';
      tooltip.style.left = `${left}px`;
      tooltip.style.top = `${top}px`;
      tooltip.style.transform = 'translate(-50%, -100%)';
      tooltip.style.visibility = 'visible';
      tooltip.style.opacity = '1';
      tooltip.style.zIndex = '9999';
    }
  }

  onMouseLeave(event: MouseEvent) {
    const container = event.currentTarget as HTMLElement;
    const tooltip = container.querySelector('.custom-tooltip') as HTMLElement;
    if (tooltip) {
      tooltip.style.visibility = 'hidden';
      tooltip.style.opacity = '0';
    }
  }
  // Filter Modal Methods
  showFilterModal(): void {
    this.isFilterVisible = true;
  }
  handleFiltersApplied(filters: any): void {
    this.appliedFilters = { ...filters };
    this.searchTerm = ''; // Clear search when filters are applied
    this.applyFilters();
    this.isFilterVisible = false;
  }
  handleFiltersReset(): void {
    this.appliedFilters = {};
    this.searchTerm = '';
    this.filteredData = [...this.listOfData]; // Reset to original data
    this.isFilterVisible = false;
  }
  private applyFilters(): void {
    let filtered = [...this.listOfData];
    // Status filter (in_progress, completed, pending)
    if (this.appliedFilters.status && this.appliedFilters.status.trim() !== '') {
      filtered = filtered.filter(item =>
        item.status?.toLowerCase() === this.appliedFilters.status.toLowerCase()
      );
    }
    // Location filter (multi-select)
    if (this.appliedFilters.location && Array.isArray(this.appliedFilters.location) && this.appliedFilters.location.length > 0) {
      filtered = filtered.filter(item =>
        this.appliedFilters.location.includes(item.userLocation)
      );
    }
    // Format filter (integrated, non-integrated)
    if (this.appliedFilters.format && this.appliedFilters.format.trim() !== '') {
      filtered = filtered.filter(item =>
        item.format_of_contest?.toLowerCase() === this.appliedFilters.format.toLowerCase()
      );
    }
    // Type filter (private, public)
    if (this.appliedFilters.type && this.appliedFilters.type.trim() !== '') {
      filtered = filtered.filter(item =>
        item.type?.toLowerCase() === this.appliedFilters.type.toLowerCase()
      );
    }

    // View Type filter (Recent Contest, Popular Contest, etc.)
    if (this.appliedFilters.viewType && this.appliedFilters.viewType.trim() !== '') {
      filtered = filtered.filter(item =>
        item.view_type === this.appliedFilters.viewType
      );
    }

    // Level filter (if applicable)
    if (this.appliedFilters.level && this.appliedFilters.level > 0) {
      filtered = filtered.filter(item =>
        item.levelsCompleted >= this.appliedFilters.level
      );
    }

    // Timeline filter (upcoming, ongoing, expired)
    if (this.appliedFilters.timeline && this.appliedFilters.timeline.trim() !== '') {
      const now = new Date();
      filtered = filtered.filter(item => {
        if (!item.joinDate || item.joinDate === 'N/A') return false;
        const joinDate = new Date(item.joinDate);
        if (this.appliedFilters.timeline === 'upcoming') {
          return joinDate > now;
        } else if (this.appliedFilters.timeline === 'ongoing') {
          const thirtyDaysAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
          return joinDate <= now && joinDate >= thirtyDaysAgo;
        } else if (this.appliedFilters.timeline === 'expired') {
          const thirtyDaysAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
          return joinDate < thirtyDaysAgo;
        }
        return true;
      });
    }

    this.filteredData = filtered;
  }

  onSearch(): void {
    const term = this.searchTerm.trim().toLowerCase();
    // If search is empty
    if (!term) {
      // If filters are applied, show filtered data
      if (Object.keys(this.appliedFilters).length > 0) {
        this.applyFilters();
      } else {
        // Otherwise show all data
        this.filteredData = [...this.listOfData];
      }
      return;
    }
    // Get base data (either filtered or all)
    let baseData: any[];
    if (Object.keys(this.appliedFilters).length > 0) {
      // Apply filters first to get base data
      let filtered = [...this.listOfData];
      // Status filter
      if (this.appliedFilters.status && this.appliedFilters.status.trim() !== '') {
        filtered = filtered.filter(item =>
          item.status?.toLowerCase() === this.appliedFilters.status.toLowerCase()
        );
      }
      // Location filter
      if (this.appliedFilters.location && Array.isArray(this.appliedFilters.location) && this.appliedFilters.location.length > 0) {
        filtered = filtered.filter(item =>
          this.appliedFilters.location.includes(item.userLocation)
        );
      }
      // Format filter
      if (this.appliedFilters.format && this.appliedFilters.format.trim() !== '') {
        filtered = filtered.filter(item =>
          item.format_of_contest?.toLowerCase() === this.appliedFilters.format.toLowerCase()
        );
      }
      // Type filter
      if (this.appliedFilters.type && this.appliedFilters.type.trim() !== '') {
        filtered = filtered.filter(item =>
          item.type?.toLowerCase() === this.appliedFilters.type.toLowerCase()
        );
      }
      // View Type filter
      if (this.appliedFilters.viewType && this.appliedFilters.viewType.trim() !== '') {
        filtered = filtered.filter(item =>
          item.view_type === this.appliedFilters.viewType
        );
      }
      // Level filter
      if (this.appliedFilters.level && this.appliedFilters.level > 0) {
        filtered = filtered.filter(item =>
          item.levelsCompleted >= this.appliedFilters.level
        );
      }
      // Timeline filter
      if (this.appliedFilters.timeline && this.appliedFilters.timeline.trim() !== '') {
        const now = new Date();
        filtered = filtered.filter(item => {
          if (!item.joinDate || item.joinDate === 'N/A') return false;
          const joinDate = new Date(item.joinDate);
          if (this.appliedFilters.timeline === 'upcoming') {
            return joinDate > now;
          } else if (this.appliedFilters.timeline === 'ongoing') {
            const thirtyDaysAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
            return joinDate <= now && joinDate >= thirtyDaysAgo;
          } else if (this.appliedFilters.timeline === 'expired') {
            const thirtyDaysAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
            return joinDate < thirtyDaysAgo;
          }
          return true;
        });
      }
      baseData = filtered;
    } else {
      baseData = [...this.listOfData];
    }
    // Now apply search on the base data
    this.filteredData = baseData.filter(item =>
      (item.participant?.toLowerCase().includes(term)) ||
      (item.email?.toLowerCase().includes(term)) ||
      (item.userLocation?.toLowerCase().includes(term)) ||
      (item.prize?.toLowerCase().includes(term)) ||
      (item.joinDate?.toLowerCase().includes(term)) ||
      (item.format_of_contest?.toLowerCase().includes(term)) ||
      (item.type?.toLowerCase().includes(term)) ||
      (item.view_type?.toLowerCase().includes(term))
    );
  }
  // Helper method to get display data for table
  get displayData(): any[] {
    const hasActiveFiltering =
      this.filteredData.length > 0 ||
      Object.keys(this.appliedFilters).length > 0 ||
      this.searchTerm.trim() !== '';
    return hasActiveFiltering ? this.filteredData : this.listOfData;
  }

  hasActiveFilters(): boolean {
    return !!(this.appliedFilters.timeline || this.appliedFilters.level ||
      this.appliedFilters.status || this.appliedFilters.format ||
      this.appliedFilters.type || this.appliedFilters.viewType ||
      this.appliedFilters.location);
  }
  clearAllFilters(): void {

    this.searchTerm = '';
    this.appliedFilters = {};
    if (this.filterModalComponent) {
      this.filterModalComponent.filterForm.reset({
        timeline: null,
        level: null,
        status: null,
        format: null,
        type: null,
        viewType: null,
        location: []
      });
    }
    this.applyFilters();
  }
  downloadPDF() {
    const dataToExport = this.displayData;
    if (!dataToExport || dataToExport.length === 0) {
      this.sharedService.createNotification('error', 'No Contest Data Found');
      return;
    }
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4',
    });
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    let currentY = 15;
    // Header Section
    doc.setFontSize(22);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0, 0, 0);
    doc.text('Luqta Contest Monitoring Report', pageWidth / 2, currentY, {
      align: 'center',
    });
    currentY += 15;
    // Table with exact same columns as image
    const bodyRows = dataToExport.map((item: any) => [
      item.contestId || item.id || 'N/A',
      item.contestName || item.contest_name || 'N/A',
      item.format_of_contest || 'N/A',
      item.type || 'N/A',
      item.levelsCompleted || item.totalLevels || '0',
      item.userLocation || 'N/A',
      item.prize || item.status || 'N/A',
      item.gender || 'N/A',
      item.age || 'All',
    ]);
    autoTable(doc, {
      startY: currentY,
      head: [
        [
          'ID',
          'Contest Name',
          'Format',
          'Type',
          'Levels',
          'Location',
          'Prize',
          'Gender',
          'Age',
        ],
      ],
      body: bodyRows,
      styles: {
        fontSize: 9,
        cellPadding: 3,
        overflow: 'linebreak',
        cellWidth: 'wrap',
        halign: 'center',
        valign: 'middle',
      },
      headStyles: {
        fillColor: [44, 62, 80],
        textColor: 255,
        fontStyle: 'bold',
        halign: 'center',
        valign: 'middle',
        fontSize: 10,
      },
      bodyStyles: {
        textColor: 50,
        halign: 'center',
        valign: 'middle',
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245],
      },
      columnStyles: {
        0: { cellWidth: 20 },
        1: { cellWidth: 40 },
        2: { cellWidth: 30 },
        3: { cellWidth: 25 },
        4: { cellWidth: 20 },
        5: { cellWidth: 35 },
        6: { cellWidth: 40 },
        7: { cellWidth: 20 },
        8: { cellWidth: 20 },
      },
      margin: { top: 5, left: 10, right: 10 },
      didDrawPage: function (data) {
        // Footer
        const pageCount = doc.internal.pages.length - 1;
        doc.setFontSize(9);
        doc.setTextColor(100);
        doc.text(
          `Page ${data.pageNumber} of ${pageCount}`,
          pageWidth / 2,
          pageHeight - 10,
          { align: 'center' }
        );
      },
    });
    // Save the PDF
    const timestamp = new Date().toISOString().split('T')[0];
    const filename = `Contest_Monitoring_Report_${timestamp}.pdf`;
    doc.save(filename);
    // Show success notification
    this.sharedService.createNotification(
      'success',
      'PDF downloaded successfully'
    );
  }

  downloadExcel() {
    const dataToExport = this.displayData;
    if (!dataToExport || dataToExport.length === 0) {
      this.sharedService.createNotification('error', 'No Contest Data Found');
      return;
    }

    // Prepare data for Excel
    const excelData = dataToExport.map((item: any) => {
      return {
        'ID': item.contestId || item.id || 'N/A',
        'Participant Name': item.participant || item.userName || 'N/A',
        'Email': item.email || 'N/A',
        'Location': item.userLocation || 'N/A',
        'Prize/Status': item.prize || item.status || 'N/A',
        'Join Date': item.joinDate || 'N/A',
        'Format': item.format_of_contest || 'N/A',
        'Type': item.type || 'N/A',
        'Levels Completed': item.levelsCompleted || 0,
        'Gender': item.gender || 'N/A',
        'Age': item.age || 'All',
      };
    });

    // Create worksheet
    const worksheet = XLSX.utils.json_to_sheet(excelData);

    // Set column widths
    const columnWidths = [
      { wch: 8 },   // ID
      { wch: 25 },  // Participant Name
      { wch: 30 },  // Email
      { wch: 20 },  // Location
      { wch: 15 },  // Prize/Status
      { wch: 15 },  // Join Date
      { wch: 15 },  // Format
      { wch: 12 },  // Type
      { wch: 18 },  // Levels Completed
      { wch: 10 },  // Gender
      { wch: 10 },  // Age
    ];
    worksheet['!cols'] = columnWidths;

    // Create workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Participant Report');

    // Generate Excel file
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    // Save file
    const timestamp = new Date().toISOString().split('T')[0];
    const filename = `Participant_Report_${timestamp}.xlsx`;
    saveAs(blob, filename);

    this.sharedService.createNotification(
      'success',
      'Excel downloaded successfully'
    );
  }
}